
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { Menu, User, Info, Zap } from 'lucide-react';
import { APP_ICON_PATH, APP_NAME } from '@/config/branding';
import { IS_DEMO } from '@/core/environment';

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden bg-mesh flex-col text-[var(--text-primary)]">
            {IS_DEMO && (
                <div className="bg-[var(--accent)] caution-stripe border-b-2 border-black text-[#000] px-4 py-2 flex items-center justify-between font-display text-lg tracking-widest z-50">
                    <div className="flex items-center gap-3">
                        <Zap size={18} className="animate-pulse" />
                        <span>&gt;&gt;&gt; MODO DEMO: LOS DATOS SON TEMPORALES Y NO SE GUARDARÁN.</span>
                    </div>
                    <div className="flex items-center gap-4">
                        <a href="https://github.com/reservaselrinconcito-stack/barberpro-app/releases/latest" className="underline hover:opacity-80 font-bold uppercase">DESCARGAR APP NATIVA</a>
                    </div>
                </div>
            )}
            <div className="flex flex-1 overflow-hidden relative">
                {/* Sidebar Component */}
                <Sidebar
                    isOpen={sidebarOpen}
                    toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
                />

                {/* Mobile Header */}
                <div className="fixed top-0 left-0 right-0 h-16 bg-[#0c0c0e] border-b-2 border-[var(--accent)] flex items-center px-4 md:hidden z-30 shadow-[0_4px_20px_var(--accent-soft)]">
                    <button onClick={() => setSidebarOpen(true)} className="p-2 text-[var(--accent)] hover:text-white transition-colors">
                        <Menu size={28} />
                    </button>
                    <div className="ml-4 flex items-center gap-4 min-w-0">
                        <div className="w-10 h-10 cut-corner border-2 border-[var(--accent)] bg-[#030303] p-1.5 flex-shrink-0 relative">
                            <img src={APP_ICON_PATH} alt="" className="w-full h-full object-contain relative z-10 filter sepia brightness-150 hue-rotate-[#d4a017]" />
                        </div>
                        <span className="font-bold text-2xl font-display text-[var(--text-primary)] tracking-widest uppercase">{APP_NAME}</span>
                    </div>
                </div>

                {/* Main Content Area */}
                <main className="flex-1 overflow-y-auto overflow-x-hidden md:ml-64 pt-16 md:pt-0 relative">
                    <div className="container mx-auto px-4 py-8 md:px-8 absolute inset-0 bg-gradient-to-br from-transparent via-[#000]/20 to-[#000]/60 pointer-events-none z-0"></div>
                    <div className="container mx-auto px-4 py-8 md:px-8 relative z-10 animate-ignition">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
